import { PortalRouterMatch } from '@willow/types-iso';

import { LenderAvatar } from './LenderAvatar';

import s from './FindPortal.module.scss';

interface Props {
  match: PortalRouterMatch;
}

export const LenderRow = ({ match }: Props) => (
  <span className={s.lenderRow}>
    <LenderAvatar name={match.name} logoUrl={match.logoUrl} />
    <span className={s.lenderText}>
      <span className={s.lenderName}>{match.name}</span>
      <span className={s.lenderHostname}>{match.hostname}</span>
    </span>
  </span>
);
